import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Home, BookOpen, ShoppingBag, Calculator } from 'lucide-react';

const LINKS = [
  { to: '/', label: 'Home', icon: Home, testid: 'not-found-home-link' },
  { to: '/blog', label: 'Blog', icon: BookOpen, testid: 'not-found-blog-link' },
  { to: '/shop', label: 'Shop', icon: ShoppingBag, testid: 'not-found-shop-link' },
  { to: '/tools', label: 'Tools', icon: Calculator, testid: 'not-found-tools-link' },
];

export default function NotFoundPage() {
  useEffect(() => {
    document.title = 'Page Not Found (404) | NinjAthlete';
    let robots = document.querySelector('meta[name="robots"]');
    const prev = robots ? robots.getAttribute('content') : null;
    if (!robots) {
      robots = document.createElement('meta');
      robots.setAttribute('name', 'robots');
      document.head.appendChild(robots);
    }
    robots.setAttribute('content', 'noindex, follow');
    return () => {
      if (prev) robots.setAttribute('content', prev);
      else robots.remove();
      document.title = 'NinjAthlete | Biohacking, Peptide Therapy & Performance Optimization';
    };
  }, []);

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-6 py-24 bg-[#0B0B0C]" data-testid="not-found-page">
      <div className="text-left max-w-xl w-full">
        <p className="text-[#C7FA3E] text-xs uppercase tracking-[0.3em] font-bold mb-4">Error 404</p>
        <h1
          className="text-5xl sm:text-6xl text-white mb-4"
          style={{ fontFamily: 'Anton, Bebas Neue, sans-serif' }}
          data-testid="not-found-heading"
        >
          Page Not Found
        </h1>
        <p className="text-zinc-400 text-base mb-8" data-testid="not-found-message">
          The page you&apos;re looking for doesn&apos;t exist or has moved. Try one of these instead:
        </p>
        <div className="flex flex-wrap gap-3">
          {LINKS.map(({ to, label, icon: Icon, testid }) => (
            <Link
              key={to}
              to={to}
              className="inline-flex items-center gap-2 px-5 py-2.5 border border-zinc-700 text-zinc-200 text-sm font-bold uppercase tracking-wider hover:border-[#C7FA3E] hover:text-[#C7FA3E] transition-colors"
              data-testid={testid}
            >
              <Icon className="w-4 h-4" /> {label}
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
